import { RangePickerProps } from 'antd/lib/date-picker';
import { RangePickerGlobalStyles, StyledRangePicker } from './styles';

const RangePicker: React.FC<RangePickerProps> = (props) => {
    return (
        <>
            <RangePickerGlobalStyles />
            <StyledRangePicker {...props} />
        </>
    );
};

export default RangePicker;
